import { render, staticRenderFns } from "./friendsList.vue?vue&type=template&id=60c5cede&scoped=true&lang=pug&"
import script from "./friendsList.vue?vue&type=script&lang=js&"
export * from "./friendsList.vue?vue&type=script&lang=js&"
import style0 from "./friendsList.vue?vue&type=style&index=0&id=60c5cede&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c5cede",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c5cede')) {
      api.createRecord('60c5cede', component.options)
    } else {
      api.reload('60c5cede', component.options)
    }
    module.hot.accept("./friendsList.vue?vue&type=template&id=60c5cede&scoped=true&lang=pug&", function () {
      api.rerender('60c5cede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/myPage/userId/friendsList.vue"
export default component.exports